import React from "react";
import "../../css/footer.scss";
import { Link } from "react-router-dom";

const Footer = () => {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer" role="contentinfo" aria-label="Site footer">
      <div className="footer__middle">
        <button className="footer__country" aria-label="Select country">
          <span className="flag" aria-hidden="true">
            🇺🇸
          </span>
          <span className="country-text">United States · English</span>
        </button>
      </div>

      <div className="footer__bottom">
        <div className="footer__center">
          <div className="footer__copyright">© 2010–2026 HeartLink</div>
          <ul className="footer__legal">
            <li>
              <Link onClick={toTop} to="/terms">
                Terms
              </Link>
            </li>
            <li>
              <Link onClick={toTop} to="/privacy">
                Privacy Notice
              </Link>
            </li>
            <li>
              <Link onClick={toTop} to="/legal">
                Legal
              </Link>
            </li>
            <li>
              <Link onClick={toTop} to="/accessibility">
                Accessibility Statement
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
